// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: channel/channel_management_event.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Value } from "../google/protobuf/struct";

export const protobufPackage = "channel";

export interface ChannelManagementEvent {
  event: { [key: string]: any | undefined };
}

export interface ChannelManagementEvent_EventEntry {
  key: string;
  value: any | undefined;
}

function createBaseChannelManagementEvent(): ChannelManagementEvent {
  return { event: {} };
}

export const ChannelManagementEvent: MessageFns<ChannelManagementEvent> = {
  encode(message: ChannelManagementEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.event).forEach(([key, value]) => {
      if (value !== undefined) {
        ChannelManagementEvent_EventEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
      }
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelManagementEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelManagementEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = ChannelManagementEvent_EventEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.event[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelManagementEvent {
    return {
      event: isObject(object.event)
        ? Object.entries(object.event).reduce<{ [key: string]: any | undefined }>((acc, [key, value]) => {
          acc[key] = value as any | undefined;
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: ChannelManagementEvent): unknown {
    const obj: any = {};
    if (message.event) {
      const entries = Object.entries(message.event);
      if (entries.length > 0) {
        obj.event = {};
        entries.forEach(([k, v]) => {
          obj.event[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelManagementEvent>, I>>(base?: I): ChannelManagementEvent {
    return ChannelManagementEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelManagementEvent>, I>>(object: I): ChannelManagementEvent {
    const message = createBaseChannelManagementEvent();
    message.event = Object.entries(object.event ?? {}).reduce<{ [key: string]: any | undefined }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value;
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseChannelManagementEvent_EventEntry(): ChannelManagementEvent_EventEntry {
  return { key: "", value: undefined };
}

export const ChannelManagementEvent_EventEntry: MessageFns<ChannelManagementEvent_EventEntry> = {
  encode(message: ChannelManagementEvent_EventEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      Value.encode(Value.wrap(message.value), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelManagementEvent_EventEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelManagementEvent_EventEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelManagementEvent_EventEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object?.value) ? object.value : undefined,
    };
  },

  toJSON(message: ChannelManagementEvent_EventEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelManagementEvent_EventEntry>, I>>(
    base?: I,
  ): ChannelManagementEvent_EventEntry {
    return ChannelManagementEvent_EventEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelManagementEvent_EventEntry>, I>>(
    object: I,
  ): ChannelManagementEvent_EventEntry {
    const message = createBaseChannelManagementEvent_EventEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
